import React, { Fragment } from 'react';
import { useNavigate } from "react-router-dom";
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Avatar from '@mui/material/Avatar';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import TableSortLabel from '@mui/material/TableSortLabel';
import { visuallyHidden } from '@mui/utils';

import { dateOptionsMidTime } from '../../utils/dateoptions';

const columns = [
    // { id: 'fieldid', label: 'Field Label', minWidth: 170, align: 'left', format: (value) => value.toLocaleString('en-US'),}, or .toFixed(2), etc.
    { id: 'img', label: '' },
    { id: 'lastName', label: 'Last Name' },
    { id: 'firstName', label: 'First Name' },
    { id: 'username', label: 'Username' },
    { id: 'status', label: 'Status' },
    { id: 'userType', label: 'Type' },
    { id: 'lastLogin', label: 'Last Login' },
];

export default function DataTable(props) {
    const { loading, data, currentLimit, setCurrentLimit, getPage, setGetPage, sort, setSort, sortDir, setSortDir } = props;

    let navigate = useNavigate();

    let data_totalResults=0, data_totalPages=0, data_getPage=0, data_currentLimit=0, paginationData, data_sortField, data_sortDir, dataToRender;

    if(data){
        data_totalResults = parseInt(data?.users[0].totalResults);
        data_totalPages = parseInt(data?.users[0].totalPages);
        data_getPage = parseInt(data?.users[0].getPage);
        data_currentLimit = parseInt(data?.users[0].currentLimit);
        paginationData = { data_totalResults, data_totalPages, data_getPage, data_currentLimit };
        data_sortField = data?.users[0].sortField;
        data_sortDir = data?.users[0].sortDir;
        dataToRender = data?.users[0].results;
    }

    const handleChangePage = (event, newPage) => {
        setGetPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setCurrentLimit(+event.target.value);
        setGetPage(0);
    };

    const createSortHandler = (property) => (event) => {
        handleRequestSort(event, property);
    };

    const handleRequestSort = (event, property) => {
        const isAsc = sort === property && sortDir === 'asc';
        setSort(property);
        setSortDir(isAsc ? 'desc' : 'asc');
    };

    const clickRow = (rid) => {
        navigate(`/users/detail/${rid}`);
    }

    return (
        <Paper sx={{ width: '100%', overflow: 'hidden' }}>
            {loading ?
                <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={true}>
                    <CircularProgress sx={{color:'#c9fb00'}} thickness={1} size={60} />
                </Backdrop>
                :
                <Fragment>
                    <TableContainer>
                        <Table stickyHeader aria-label="sticky table">
                            <TableHead>
                                <TableRow>
                                    {columns.map((column) => (
                                        <TableCell
                                            key={column.id}
                                            align={column.align}
                                            style={{ minWidth: column.minWidth }}
                                        >
                                            <TableSortLabel
                                                active={sort === column.id}
                                                direction={sort === column.id ? sortDir : 'asc'}
                                                onClick={createSortHandler(column.id)}
                                            >
                                                {column.label}
                                                {sort === column.id ? (
                                                    <Box component="span" sx={visuallyHidden}>
                                                        {sortDir === 'desc' ? 'sorted descending' : 'sorted ascending'}
                                                    </Box>
                                                ) : null}
                                            </TableSortLabel>


                                        </TableCell>
                                    ))}
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {data_totalResults > 0 ?
                                dataToRender
                                    .map((row) => {
                                        const updatedFormatted = (new Date(row.lastLogin)).toLocaleDateString(undefined, dateOptionsMidTime);
                                        return (
                                            <TableRow hover role="button" tabIndex={-1} key={row.rid} onClick={()=>clickRow(row.rid)} sx={{cursor: 'pointer'}}>
                                                <TableCell>
                                                    <Avatar alt={row.name} src="" />
                                                </TableCell>
                                                <TableCell>{row.lastName}</TableCell>
                                                <TableCell>{row.firstName}</TableCell>
                                                <TableCell>{row.casedUsername}</TableCell>
                                                <TableCell>{row.status}</TableCell>
                                                <TableCell>{row.userType}</TableCell>
                                                <TableCell>{updatedFormatted}</TableCell>
                                            </TableRow>
                                        );
                                    })
                                :
                                <TableRow>
                                    <TableCell colSpan="100%">No Results</TableCell>
                                </TableRow>
                                }

                            </TableBody>
                        </Table>
                    </TableContainer>
                    <TablePagination
                        rowsPerPageOptions={[10, 25, 100]}
                        component="div"
                        count={data_totalResults}
                        rowsPerPage={currentLimit}
                        page={getPage}
                        onPageChange={handleChangePage}
                        onRowsPerPageChange={handleChangeRowsPerPage}
                    />
                </Fragment>
            }
        </Paper>
    );
}